import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-indicator",
  "use": "icon-indicator-usage",
  "viewBox": "0 0 2048 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 2048 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-indicator\"><path d=\"M1536.45 1024H0V0h1536.45l512.15 510.47z\" fill=\"#FC1616\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol